import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { KEOCardDetailsDto, KEOCollecteddDto, KEOGeneratedDto, RecordCardService } from "../../../../../api";
import { AlertService, MessageType } from "../../../services/alert.service";

@UntilDestroy()
@Component({
  selector: "app-filed-collected-waste-transfer-cards",
  templateUrl: "./filed-collected-waste-transfer-cards.component.html",
  styleUrls: ["./filed-collected-waste-transfer-cards.component.scss"],
})
export class FiledCollectedWasteTransferCardsComponent implements OnInit {
  public details: KEOCollecteddDto;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  loading = false;
  constructor(public dialogRef: MatDialogRef<FiledCollectedWasteTransferCardsComponent>, private service: RecordCardService, @Inject(MAT_DIALOG_DATA) public data: { cardId: string }, private alertService: AlertService) {}

  load() {
    this.loading = true;
    this.service.getKEOCollectedList(this.data.cardId, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(
      (result) => {
        this.details = result;
        this.paginator.length = result.collectedKeos.totalResultNumber;
        console.log(result);
      },
      (error) => this.alertService.showMessage(error, MessageType.Error),
      () => (this.loading = false)
    );
  }

  ngOnInit(): void {
    this.load();
    this.paginator.page.pipe(untilDestroyed(this)).subscribe((p) => this.load());
  }
}
